// Lazily loads CodeMirror 6 on demand: the theme editor (CSS) and read-only code viewers (JSON).
//
// IMPORTANT: the dynamic import() lives here, in a module that is part of the MAIN bundle (it's
// imported by webcy.js). Initiating the import from the entry's context keeps the heavy CodeMirror
// graph in its own async chunk *and* makes it actually load. Triggering the same import() from
// inside a lazily-loaded Vue chunk (e.g. directly in themeEditor.vue) hangs the app — the exact
// failure mode we hit with @microsoft/signalr, which is why $chatHub/$deviceHub are main-bundle
// singletons too. See the "signalr-lazy-chunk-hang" note.
//
// The result is memoized so repeated opens of the editor don't re-fetch.
let cmPromise = null;

export function loadCodeMirror() {
    if (!cmPromise) {
        cmPromise = Promise.all([
            import('codemirror'),
            import('@codemirror/lang-css'),
            import('@codemirror/theme-one-dark'),
            import('@codemirror/lang-json'),
            import('@codemirror/state'),
        ]).then(([cm, langCss, themeOneDark, langJson, state]) => ({
            EditorView: cm.EditorView,
            basicSetup: cm.basicSetup,
            css: langCss.css,
            oneDark: themeOneDark.oneDark,
            json: langJson.json,
            EditorState: state.EditorState,
        })).catch((e) => {
            // Allow a later retry if the chunk failed to load (offline, transient network).
            cmPromise = null;
            throw e;
        });
    }
    return cmPromise;
}
